import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api";
import Button from "../components/Button";
import { useToast } from "../contexts/ToastContext";
import "./scss/manager-market-form.scss";
import FloatingInput from "../components/FloatingInput";
import SearchSelect from "../components/SearchSelect";
import ManagerFooter from "../components/ManagerFooter";
import BackButton from "../components/BackButton";
import Breadcrumbs from "../components/Breadcrumbs";

export default function ManagerMarketFormPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { showToast } = useToast();

  const isEdit = !!id;

  const [businessType, setBusinessType] = useState("IP"); // IP | LLC

  const [form, setForm] = useState({
    cityName: "Москва",
    name: "",
    phone: "",
    email: "",
    street: "",

    // IP
    ipFullName: "",
    ogrnip: "",
    inn: "",
    passportSerial: "",
    passportFio: "",
    birthDate: "",
    birthPlace: "",
    issuedBy: "",
    registrationAddress: "",

    // LLC
    legalName: "",
    legalAddress: "",
    innLlc: "",
    ogrn: "",
    kpp: "",
    directorName: "",

    // Bank
    nameBank: "",
    settlementAccount: "",
    bikAccount: "",
    correspondentAccount: ""
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (key, value) => {
    setForm(prev => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
  if (isEdit) {
    loadMarket();
  }
}, [id]);

async function loadMarket() {
  try {
    setLoading(true);

    const { data } = await api.get(`/api/manager/markets/${id}/edit`);

    // Определяем тип бизнеса
    const type = data.typeBusiness === "LLC" ? "LLC" : "IP";
    setBusinessType(type);

    setForm(prev => ({
      ...prev,

      cityName: data.cityName || "",
      name: data.name || "",
      phone: data.phone || "",
      email: data.email || "",
      street: data.street || "",

      // IP
      ipFullName: data.ipFullName || "",
      ogrnip: data.ogrnip || "",
      inn: data.inn || "",
      passportSerial: data.passportSerial || "",
      passportFio: data.passportFio || "",
      birthDate: data.birthDate || "",
      birthPlace: data.birthPlace || "",
      issuedBy: data.issuedBy || "",
      registrationAddress: data.registrationAddress || "",

      // LLC
      legalName: data.legalName || "",
      legalAddress: data.legalAddress || "",
      innLlc: data.innLlc || "",
      ogrn: data.ogrn || "",
      kpp: data.kpp || "",
      directorName: data.directorName || "",

      // Bank
      nameBank: data.nameBank || "",
      settlementAccount: data.settlementAccount || "",
      bikAccount: data.bikAccount || "",
      correspondentAccount: data.correspondentAccount || ""
    }));

  } catch {
    showToast("Ошибка загрузки данных");
  } finally {
    setLoading(false);
  }
}

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const payload = {
        cityName: form.cityName,
        name: form.name,
        phone: form.phone,
        email: form.email,
        street: form.street,
        typeBusiness: businessType,

        nameBank: form.nameBank,
        settlementAccount: form.settlementAccount,
        bikAccount: form.bikAccount,
        correspondentAccount: form.correspondentAccount,

        // IP
        ipFullName: businessType === "IP" ? form.ipFullName : null,
        ogrnip: businessType === "IP" ? form.ogrnip : null,
        inn: businessType === "IP" ? form.inn : null,
        passportSerial: businessType === "IP" ? form.passportSerial : null,
        passportFio: businessType === "IP" ? form.passportFio : null,
        birthDate: businessType === "IP" ? form.birthDate : null,
        birthPlace: businessType === "IP" ? form.birthPlace : null,
        issuedBy: businessType === "IP" ? form.issuedBy : null,
        registrationAddress: businessType === "IP" ? form.registrationAddress : null,

        // LLC
        legalName: businessType === "LLC" ? form.legalName : null,
        legalAddress: businessType === "LLC" ? form.legalAddress : null,
        innLlc: businessType === "LLC" ? form.innLlc : null,
        ogrn: businessType === "LLC" ? form.ogrn : null,
        kpp: businessType === "LLC" ? form.kpp : null,
        directorName: businessType === "LLC" ? form.directorName : null
      };

      if (isEdit)
        await api.put(`/api/manager/markets/${id}`, payload);
      else
        await api.post("/api/manager/markets", payload);

      showToast("Сохранено", "info");

    } catch {
      showToast("Ошибка сохранения");
    } finally {
      setLoading(false);
    }
  };

  if (loading && isEdit) {
    return <div className="manager-market-form loading">Загрузка...</div>;
  }

  return (
    <>
    <div className="manager-market-form">
      <BackButton />

      <Breadcrumbs
        items={[
          { label: "Главная", path: "/manager/dashboard" },
          { label: "Добавление магазина" }
        ]}
      />
      <h2>{isEdit ? "Редактирование магазина" : "Добавление магазина"}</h2>
      {/* Адрес */}
      <div className="block">
        <h4>Адрес</h4>
        <SearchSelect
          label="Город"
          value={form.cityName}
          onChange={val => handleChange("cityName", val)}
          options={[
            "Москва"
          ]}
          recent={[
            "Москва"
          ]}
        />
        <FloatingInput
          label="Улица"
          value={form.street}
          onChange={e => handleChange("street", e.target.value)}
        />

        <h4>Основное</h4>
        <FloatingInput label="Название магазина"
          value={form.name}
          onChange={e => handleChange("name", e.target.value)} />

        <FloatingInput label="Телефон магазина"
          value={form.phone}
          onChange={e => handleChange("phone", e.target.value)} />

        <FloatingInput label="E-mail"
          value={form.email}
          onChange={e => handleChange("email", e.target.value)} />
      </div>

      {/* Тип бизнеса */}
      <div className="business-toggle">
        <button
          className={businessType === "IP" ? "active" : ""}
          onClick={() => setBusinessType("IP")}
        >
          ИП
        </button>

        <button
          className={businessType === "LLC" ? "active" : ""}
          onClick={() => setBusinessType("LLC")}
        >
          ООО
        </button>
      </div>

      {/* IP BLOCK */}
      {businessType === "IP" && (
        <div className="block">
          <h4>Данные ИП</h4>

          <FloatingInput label="Индивидуальный предприниматель"
            value={form.ipFullName}
            onChange={e => handleChange("ipFullName", e.target.value)} />

          <FloatingInput label="ОГРНИП"
            value={form.ogrnip}
            onChange={e => handleChange("ogrnip", e.target.value)} />

          <FloatingInput label="ИНН"
            value={form.inn}
            onChange={e => handleChange("inn", e.target.value)} />

          <h4>Паспортные данные</h4>
            <FloatingInput label="Фамилия Имя Отчество"
            value={form.passportFio}
            onChange={e => handleChange("passportFio", e.target.value)} />

          <FloatingInput label="Дата рождения"
            value={form.birthDate}
            onChange={e => handleChange("birthDate", e.target.value)} />

          <FloatingInput label="Место рождения"
            value={form.birthPlace}
            onChange={e => handleChange("birthPlace", e.target.value)} />

          <FloatingInput
            label="Серия и номер паспорта"
            value={form.passportSerial}
            onChange={e => handleChange("passportSerial", e.target.value)}
          />

          <FloatingInput label="Кем выдан"
            value={form.issuedBy}
            onChange={e => handleChange("issuedBy", e.target.value)} />

          <FloatingInput label="Адрес регистрации"
            value={form.registrationAddress}
            onChange={e => handleChange("registrationAddress", e.target.value)} />
        </div>
      )}

      {/* LLC BLOCK */}
      {businessType === "LLC" && (
        <div className="block">
          <h4>Данные ООО</h4>

          <FloatingInput label="Юридическое лицо"
            value={form.legalName}
            onChange={e => handleChange("legalName", e.target.value)} />

          <FloatingInput label="Юридический адрес"
            value={form.legalAddress}
            onChange={e => handleChange("legalAddress", e.target.value)} />

          <FloatingInput label="ИНН"
            value={form.innLlc}
            onChange={e => handleChange("innLlc", e.target.value)} />

          <FloatingInput label="ОГРН"
            value={form.ogrn}
            onChange={e => handleChange("ogrn", e.target.value)} />

          <FloatingInput label="КПП"
            value={form.kpp}
            onChange={e => handleChange("kpp", e.target.value)} />

          <h4>Генеральный директор</h4>

          <FloatingInput label="Фамилия Имя Отчество"
            value={form.directorName}
            onChange={e => handleChange("directorName", e.target.value)} />
        </div>
      )}

      {/* Bank */}
      <div className="block">
        <h4>Банковские реквизиты</h4>

        <FloatingInput label="Название банка"
          value={form.nameBank}
          onChange={e => handleChange("nameBank", e.target.value)} />

        <FloatingInput label="Расчетный счет"
          value={form.settlementAccount}
          onChange={e => handleChange("settlementAccount", e.target.value)} />

        <FloatingInput label="БИК"
          value={form.bikAccount}
          onChange={e => handleChange("bikAccount", e.target.value)} />

        <FloatingInput label="Корреспондентский счет"
          value={form.correspondentAccount}
          onChange={e => handleChange("correspondentAccount", e.target.value)} />
      </div>

      <Button
        className="btn-primary large"
        onClick={handleSubmit}
        load={loading}
      >
        {isEdit ? "Сохранить изменения" : "Добавить магазин"}
      </Button>

    </div>
    <ManagerFooter />
    </>
  );
}
